import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@app/shared/services/common/common.service';
import { ReportService } from '@app/shared/services/reports/report.service';
import { AngularCsv }from 'angular7-csv';
import { EarningRpt } from '@app/feature/store-admin/models/earningReport';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-store-admin-earning-rpt',
  templateUrl: './store-admin-earning-rpt.component.html',
  styleUrls: ['./store-admin-earning-rpt.component.css']
})
export class StoreAdminEarningRptComponent implements OnInit {

  storeList: any[] = [];
  reportList: any[] = [];
  initialItemsCount !: number;
 //  ApplicationUserId !: any;
  minDate = new Date(2018, 0, 1);
  reportingForm: FormGroup;
  isGenerateExcel = false;
  EarningRpt: EarningRpt[] = [];
  constructor(private formBuilder: FormBuilder, private commonService: CommonService, private reportService: ReportService,
    private loader: LoaderService, private notificationService: NotificationService, private errorhandlerService: ErrorhandlerService) {
    this.reportingForm = this.formBuilder.group({
      UserId: new FormControl(localStorage.getItem('userId')),
      StoreId: new FormControl(''),
      FromDate: new FormControl(''),
      ToDate: new FormControl(''),
      SkipNoOfRecord: 0,
      TakeNoRecord: 10,
      StatusId: new FormControl('')
    });
  }

  ngOnInit() {
    this.storeList = [];
    this.initialItemsCount = 0;
    this.fn_getStoreList();
  }

  /** Function to get store list */
  fn_getStoreList() {
    this.loader.show();
    this.commonService.getStoreList('', 0, 0, false, localStorage.getItem('userId'),false).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.storeList = res.Data.ResponseData;
        this.reportingForm.patchValue({
          StoreId: this.storeList[0].StoreId,
        });
        this.loader.hide();
      } else if (res.StatusCode === 204 || res.StatusCode === 404) {
        // if (this.storeList.length <= 0) {
        //   this.notificationService.error(res.Message, 'Record(s)');
        // }
        this.loader.hide();
      }
    }, err => {
      this.loader.hide();
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
    });
  }
  fn_selectedStatus(event: any) {
    this.reportingForm.patchValue({
      StatusId: event,
    });
  }
  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.reportList.find(x => x.StoreId === items[i].StoreId)) {
          this.initialItemsCount = this.reportList.push(items[i]);
        }
      }
    }
    if (this.initialItemsCount > 0) {
      this.isGenerateExcel = true;
    } else {
      this.isGenerateExcel = false;
      this.notificationService.info('No matching record(s) found', 'Record');
    }
  }
  /** Fucn to update the order status */
  fn_selectedStore(event: any) {
    this.reportingForm.patchValue({
      StoreId: event,
    });
  }
  FromDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.reportingForm.patchValue({
      FromDate: event.value,
    });
    this.minDate = new Date(this.reportingForm.controls.FromDate.value);
  }

  ToDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.reportingForm.patchValue({
      ToDate: event.value,
    });
  }

  fn_getEarningReport(form: FormGroup, callType: string) {
    if (callType === 'form') {
      this.initialItemsCount = 0;
      this.reportingForm.patchValue({
        SkipNoOfRecord: this.initialItemsCount,
        TakeNoRecord: 10,
        StatusId: 1
        });
        this.reportList = [];
    }
    if (callType === 'scroll' &&  this.initialItemsCount === 0) {
      return;
    }
    form.value.FromDate = (form.value.FromDate !== null && form.value.FromDate !== '')
    ? form.value.FromDate.toUTCString() : '' ;
    form.value.ToDate = (form.value.ToDate !== null && form.value.ToDate !== '')
    ? form.value.ToDate.toUTCString() : '' ;
    this.reportingForm.patchValue({
      SkipNoOfRecord: this.initialItemsCount,
      TakeNoRecord: 10
      });
    this.loader.lazyLoaderShow();
    this.reportService.getStoreAdminEarningReport(form.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
        this.loader.lazyLoaderHide();
      } else if (res.StatusCode === 400) {
        this.notificationService.error(res.Message, 'Try again');
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
      }
      this.loader.lazyLoaderHide();
    }, (err: any) => {
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
      this.loader.lazyLoaderHide();
    });
  }

  fn_DownloadSaleOrderReport() {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true,
      noDownload: false,
      headers: ['UserName',	'StoreName',	'TotalPrice($)', 'Profit($)']
    };
    this.reportList.forEach(obj => {
      const earRpt: EarningRpt = {
        Username: obj.Username,
        StoreName: obj.StoreName,
        OrderAmount: obj.OrderAmount,
        CommissionAmount: obj.CommissionAmount
      };
      this.EarningRpt.push(earRpt);
    });
    // tslint:disable-next-line:no-unused-expression
    // new Angular5Csv(this.EarningRpt, 'EarningReport', options);
    new AngularCsv(this.EarningRpt, 'EarningReport', options);
  }

}

